<template>
    <framed-layout>

        <template #center>
            <steps-progress
                :active="2"
                :steps="['Võimalik meeskond', 'Projektijuhi valimine', 'Lepingu sõlmimine']"
            ></steps-progress>
        </template>

        <template #right>
            <router-link to="/projects" class="btn-circle">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </router-link>
        </template>

        <div class="max-w-lg mx-auto step-2">
            <h1 class="text-2xl font-bold leading-tight text-center md:text-4xl lg:text-5xl">Vali projektijuht</h1>

            <div class="my-10 text-center md:text-lg">
                Süsteemi poolt välja valitud projektijuhtidest on projektist huvitatud {{ number }}
                projektijuht{{ number > 1 || number === 0 ? 'i' : '' }}
            </div>

            <button
                @click="addProjectManager()"
                class="mt-5 text-orange-400 bg-orange-200 btn-sm rounded-full py-3"
            >
              <span class="mr-3 text-xs font-bold pi pi-plus"></span>
              Kutsu uus projektijuht
            </button>

            <div class="md:my-16">
                <div
                    v-for="(person, i) in people"
                    :key="person.name"
                    :class="!person.disabled ? 'shadow-lg' : ''"
                    class="flex items-center justify-between px-8 py-4 my-3 bg-white rounded-lg"
                >
                    <div
                        class="flex items-center cursor-pointer"
                        @click="openPersonDialog(person)"
                    >
                        <div
                            :style="
                'background: url(' +
                person.image +
                ') no-repeat center center; background-size: cover;'
              "
                            class="relative w-12 h-12 mr-4 bg-gray-300 rounded-full"
                            v-badge="person.rating"
                        >
                            <div
                                v-if="false"
                                :class="!person.disabled ? 'bg-green-500' : 'bg-red-700'"
                                class="absolute bottom-0 right-0 w-3 h-3 border-2 border-white rounded-full"
                            ></div>
                        </div>

                        <div>
                          <h3 class="font-semibold text-gray-900">{{ person.name }}</h3>
                          <h4 class="text-xs">{{ person.subtitle }}</h4>
                        </div>
                    </div>

                    <div v-if="!person.disabled">
                        <radio-button :input-id="person.name" name="people" :value="people[i]"
                                      v-model="selectedPerson" />
                    </div>
                </div>
            </div>


            <Dialog v-if="dialogPerson" :visible.sync="personDialog" :closable="true" :dismissableMask="true" modal class="w-full">
              <profile :member-id="dialogPerson.id"/>
            </Dialog>

            <Dialog :visible.sync="confirmDialog" modal :closable="true">
                <div class="max-w-lg p-4 text-center md:p-8">
                    <icon name="check" width="115" height="115" vbWidth="115" vbHeight="115" stroke-width="3" class="mb-8 md:mb-12" />
                    <h3 class="mb-5 text-2xl font-semibold">Projektijuht kinnitatud</h3>
                    <p>
                      Saatsime <strong>projektijuhile</strong> teavituse.
                      Palun võta projektijuhiga ise kohe ühendust, et projekti detaile arutada ja töödega kiiremini edasi minna.
                      Projektijuhi andmed leiad projekti vaatesse minnes “Meeskonna” alt, tema nimetähtedele vajutades.
                    </p>

                    <router-link
                        to="/projects" class="w-full mt-8 md:mt-12 text-white bg-orange-400 btn xs:w-64 md:mt-20"
                    >Tagasi töölauale
                    </router-link>
                </div>
            </Dialog>

            <div class="flex flex-col items-center mt-10">
                <button
                    :class="{ 'opacity-50 pointer-events-none': !selectedPerson }"
                    class="w-full text-white bg-orange-400 btn xs:w-64"
                    @click="assignManager"
                >Kinnita projektijuht
                </button>
            </div>
        </div>
    </framed-layout>
</template>

<script>
// import axios from 'axios'
import FramedLayout from './../../Layouts/FramedLayout'
import {Area} from "@/utils/area";
import Profile from '../../components/Profile';
import {assignTeamLead, getPickTeamLead} from "@/store/project.api";

export default {
  computed: {
    Area() {
      return Area
    }
  },
    components: {
        FramedLayout,
        Profile
    },
    data() {
        return {
            projectUserId: null,
            people: [],
            number: '',
            confirmDialog: false,
            personDialog: false,
            dialogPerson: null,
            selectedPerson: null,
        }
    },
    methods: {
        openPersonDialog(person) {
            this.personDialog = true
            this.dialogPerson = person
        },
        assignManager() {
          let payload = {
            clientProjectUserId: this.$route.params.projectUserId,
            selectedProjectUserId: this.selectedPerson.projectUserId
          };
          assignTeamLead(payload).then(({data}) => {
                this.confirmDialog = true
                this.processAxiosPositiveResponse(data);
            });
        },
        async addProjectManager() {
          this.$router.push({
            path: `/project/${this.projectUserId}/add-specialist`,
            query: {
              areaId: Area.PROJECT_MANAGER,
              isLead: true
            },
          });
        },
    },
    async mounted() {
        this.projectUserId = this.$route.params.projectUserId;
        const {data} = await getPickTeamLead(this.projectUserId);
        this.people = data?.people;
        this.number = data?.number;
    },
}
</script>


<style lang="scss">
.step-2 * .p-dialog {
    max-width: 64rem !important;
}
</style>
<style scoped lang="scss">
::v-deep .p-listbox {
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;

    .p-listbox-list-wrapper {
        overflow: visible;
    }

    .p-listbox-item {
        @apply bg-white px-6 py-5 my-3 rounded-lg shadow-lg;

        &:hover {
            @apply shadow-md;

            background: #fff !important;
        }

        &.p-highlight {
            background: #fff;
            color: inherit;
        }

        &.p-disabled {
            opacity: 1;
            box-shadow: none;
        }
    }
}
</style>
